import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import { T } from "../shared/typography.styles"

/* SOLUTION CARD STYLES */

export const SolutionCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${Breakpoints.md}) {
  }
  @media (min-width: ${Breakpoints.lg}) {
  }
`

export const SolutionCardImg = styled.img``

export const SolutionCardTitle = styled.h3`
  ${T.sm.h3.bold}
  color: var(--dark-mode-body-grey);
  margin-top: 24px;
  text-align: center;
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 32px;
    ${T.lg.h4.bold}
  }
`

export const SolutionCardText = styled.p`
  ${T.sm.body.regular}
  color: var(--dark-mode-body-grey);
  text-align: center;
  margin-top: 16px;
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    margin-top: 16px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
    margin-top: 24px;
  }
`

/* SECTION STYLES */

export const SectionContainer = styled.div`
  padding: 48px 0;
  background-color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0 64px 0;
  }
`

export const SectionTitle = styled.h2`
  ${T.sm.h2.semiBold}
  color: var(--dark-mode-body-grey);
  grid-column: 1 / -1;
  text-align: center;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2.semiBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2.semiBold}
  }
`

export const SliderContainer = styled.div`
  grid-column: 2 / -2;
  margin-top: 48px;
  padding-bottom: 16px;
  width: 100%;
  @media (min-width: ${Breakpoints.md}) {
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 4 / -4;
    margin-top: 96px;
  }

  .slick-dots {
    transform: translate3D(0, 16px, 0);
    color: #fff;
    z-index: 1000;
  }

  .slick-dots li button:before {
    color: #fff;
  }
  .slick-prev {
    transform: translate3d(-50px, 0, 0);
  }
  .slick-next {
    transform: translate3d(50px, 0, 0);
  }
`
